import type { HTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'
import cx from 'helpers/cx'

import { AddIcon } from '@pleio/icons/add'

import Button from 'js/components/Button'

import styles from './AddPageButton.module.css'

type Props = HTMLAttributes<HTMLButtonElement> & {
    parentGuid?: string
}

const AddPageButton = ({ parentGuid, className, ...rest }: Props) => {
    const navigate = useNavigate()
    const location = useLocation()

    const { t } = useTranslation()

    const handleClick = () => {
        navigate('/pages/add', {
            state: {
                parentGuid,
                prevPathname: location.pathname,
            },
        })
    }

    return (
        <Button
            className={cx(styles.addButton, className)}
            size="small"
            variant="secondary"
            onClick={handleClick as any}
            {...rest}
        >
            <AddIcon style={{ marginRight: '4px' }} />
            {t('entity-cms.nav-add-page')}
        </Button>
    )
}

export default AddPageButton
